import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import { PackItemsList } from 'ui/components';
import { FormattedMessage } from 'ui/i18n';

import './SoloItem.scss';

@observer
export default class SoloItem extends Component {
	static propTypes = {
		soloItem: PropTypes.object.isRequired,
		toggleModal: PropTypes.func,
		nameIsRequired: PropTypes.bool,
		hover: PropTypes.bool,
		baseNumberRequired: PropTypes.bool,
		displayOnlyName: PropTypes.bool,
	};

	static defaultProps = {
		toggleModal: () => false,
		nameIsRequired: false,
		hover: false,
		baseNumberRequired: false,
		displayOnlyName: false,
	};

	@observable canShow = false;
	@observable alignItemsTooltipBottom = false;

	getItemName() {
		if (this.props.displayOnlyName) {
			return this.props.soloItem.name;
		} else if (
			this.props.baseNumberRequired &&
			!this.props.soloItem.is_pack &&
			this.props.soloItem.is_configurable
		) {
			return this.props.soloItem.base_number;
		}

		return this.props.soloItem.number
			? this.props.soloItem.number
			: this.props.soloItem.name;
	}

	handleOnClick(toggleModal) {
		toggleModal(this.props.soloItem);
	}

	@action
	toggle() {
		this.canShow = !this.canShow;
	}

	render() {
		const { soloItem, toggleModal, nameIsRequired, hover } = this.props;
		const linkTo = soloItem.is_pack
			? `/details/pack?promotionId=${soloItem.promotion_id}&packId=${soloItem.pack_id}&categoryId=${soloItem.category_id}`
			: `/details/item?promotionId=${soloItem.promotion_id}&categoryId=${soloItem.category_id}&itemId=${soloItem.id}&itemNumber=${soloItem.number}`;

		return (
			<div className="SoloItem">
				<div
					className="SoloItem-content"
					onMouseOver={this.toggle.bind(this)}
					onMouseOut={this.toggle.bind(this)}
				>
					<div className="SoloTitle">
						<Link to={linkTo}>
							{this.getItemName()}
							{nameIsRequired && !soloItem.is_pack && ` - ${soloItem.name}`}
						</Link>
					</div>

					{hover &&
						soloItem.is_pack &&
						<PackItemsList show={this.canShow} items={soloItem.offerings} />}
				</div>

				{soloItem.is_configurable &&
					<div
						className="choose-color"
						onClick={this.handleOnClick.bind(this, toggleModal)}
					>
						<FormattedMessage id="general.chooseColorText" />
					</div>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/SoloItem/index.js